import './style.modules.scss'

import { Spacer } from '@ampcore/adel-react'
import { BackgroundColor } from '@ampcore/ampcom-contracts'
import React from 'react'

import type { CategoriesProps } from './Categories.type'
import { CategoriesBlocks } from './CategoriesBlocks'

export const Categories: React.FC<CategoriesProps> = props => {
  const {
    description,
    headline,
    block,
    bgColor,
    columnLayout,
    isCompact,
    componentSpacing,
    testId
  } = props
  let facet = ''
  let facetColor = ''

  const columnCount = () => {
    if (columnLayout === 'three-column') {
      return 3
    } else if (isCompact) {
      return 2
    } else if (columnLayout === 'four-column') {
      return 4
    }
    return 1
  }

  const classNames = [
    'Categories',
    'u-posRelative',
    'u-paddingBottom48',
    'u-md-paddingHoriz16'
  ]

  switch (bgColor) {
    case BackgroundColor.PURPLE_TINT:
      classNames.push('u-bgColorPurpleLight10')
      break
    case BackgroundColor.MINT_TINT:
      classNames.push('u-bgColorMintLight10')
      break
    case BackgroundColor.LIME_TINT:
      classNames.push('u-bgColorLimeLight20')
      break
    case BackgroundColor.STONE:
      classNames.push('u-bgColorStone')
      break
    case BackgroundColor.BERRY_TINT:
      classNames.push('u-bgColorBerryLight10')
      break
    case BackgroundColor.ORANGE_TINT:
      classNames.push('u-bgColorOrangeLight20')
      break
    case BackgroundColor.GREY_FACET:
      facetColor = 'faded-grey'
      facet = `url(${window.AMPCOMPATH}images/facets/categories-facets-${facetColor}.png)`
      classNames.push('u-bgSizeCover')
      break
    default:
      classNames.push('u-bgColorWhite')
  }

  return (
    <Spacer spacing={componentSpacing}>
      <section
        className={classNames.join(' ')}
        data-testid={testId ? `${testId}-section` : undefined}
        style={
          facet !== ''
            ? { backgroundImage: facet, backgroundPosition: 'left' }
            : undefined
        }
      >
        <div className="u-sizeConstrained u-sm-flexJustifyCenter">
          {(headline || description) && (
            <div className="Content u-paddingTop48">
              {headline && (
                <h3
                  data-testid={testId ? `${testId}-headline` : undefined}
                  dangerouslySetInnerHTML={{ __html: headline }}
                ></h3>
              )}
              {description && (
                <div dangerouslySetInnerHTML={{ __html: description }}></div>
              )}
            </div>
          )}

          <CategoriesBlocks
            blocks={block}
            columnCount={columnCount()}
            testId={testId}
          />
        </div>
      </section>
    </Spacer>
  )
}
